export default __webpack_public_path__ + "static/media/IMG-20241005-WA0042.6ce46e57.jpg";